import template from './maximumBorrowing.template.html';

export default {
  template,
  bindings: {
    formName: '<',
    maximumBorrowing: '<',
    lenders: '<',
    documents: '<',
    contacts: '<',
    assets: '<',
    liabilities: '<',
    ticketClientTypes: '<',
    homeLoanSecurities: '<',
    fundingWorksheets: '<',
    income: '<',
    expenses: '<',
    workflow: '<',
    idTicket: '<',
    isDealOwnerBroker: '<',
    isTicketSettled: '<',
    onDownload: '&',
    onFinished: '&'
  },
  controller: class controller {
    constructor(
      $rootScope,
      $mdUtil,
      $mdMedia,
      $timeout,
      eventService,
      helperService,
      incomeService,
      expensesService,
      assetsService,
      liabilitiesService,
      financesService
    ) {
      'ngInject';

      const ctrl = this;
      ctrl.mdMedia = $mdMedia;
      ctrl.currentOrganization = $rootScope.CurrentOrganization;
      ctrl.currentDateFormat = $rootScope.CurrentDateFormatPrimary();
      ctrl.currentCurrency = $rootScope.CurrentCurrency();
      ctrl.organizationCountry = '';
      ctrl.availableIncomeTypes = [];
      ctrl.availableLiabilityTypes = [];
      ctrl.isProcessing = false;
      ctrl.isReady = false;

      ctrl.initialize = () => {
        ctrl.organizationCountry = helperService.getOrganizationCountry();
        ctrl.availableIncomeTypes = incomeService.getAvailableIncomeTypes();
        ctrl.availableLiabilityTypes = liabilitiesService.getAllLiabilityTypes();
        ctrl.maximumBorrowing = ctrl.maximumBorrowing || {};
        ctrl.lenders = ctrl.lenders || [];
        ctrl.filteredLenders = ctrl.filteredLenders || [];
        ctrl.documents = ctrl.documents || [];
        ctrl.contacts = ctrl.contacts || [];
        ctrl.assets = ctrl.assets || [];
        ctrl.liabilities = ctrl.liabilities || [];
        ctrl.ticketClientTypes = ctrl.ticketClientTypes || [];
        ctrl.homeLoanSecurities = ctrl.homeLoanSecurities || [];
        ctrl.fundingWorksheets = ctrl.fundingWorksheets || {};
        ctrl.income = ctrl.income || [];
        ctrl.expenses = _.filter(ctrl.expenses || [], (e) => e?.id && _.isUuid(e?.id));
        ctrl.workflow = ctrl.workflow || {};
        ctrl.idTicket = ctrl.idTicket || '';
        ctrl.isDealOwnerBroker = ctrl.isDealOwnerBroker || false;
        ctrl.isTicketSettled = ctrl.isTicketSettled || false;
        ctrl.personContacts = _.filter(ctrl.contacts, (c) => !c.isCompany);
        if (!ctrl.maximumBorrowing?.idLenders?.length) {
          ctrl.maximumBorrowing.idLenders = _.map(ctrl.lenders, 'id');
        }
        if (!ctrl.isTicketSettled && !ctrl.showErrorMessage()) {
          ctrl.isProcessing = true;
          ctrl.getMaximumBorrowing();
        }
      };

      ctrl.getMaximumBorrowing = () => {
        ctrl.filteredLenders = _.filter(
          ctrl.lenders || [],
          (l) => _.indexOf(ctrl.maximumBorrowing?.idLenders || [], l?.id) > -1
        );
        if (!ctrl.showErrorMessage()) {
          financesService.homeLoanMaximumBorrowing({ idTicket: ctrl.idTicket }).then((res) => {
            if (res?.status && res?.lenders?.length) {
              const len = ctrl.lenders?.length || 0;
              for (let l = 0; l < len; l += 1) {
                const lender = ctrl.lenders[l];
                const estimateData = _.find(res?.lenders || [], (i) => i?.id === lender?.id);
                if (estimateData && estimateData?.homeLoanEstimate?.length) {
                  lender.maxBorrow =
                    estimateData?.homeLoanEstimate[0]?.maximumBorrowing < 0
                      ? 0
                      : estimateData.homeLoanEstimate[0].maximumBorrowing;
                  lender.mbp = estimateData.mbp;
                }
              }
              ctrl.onFinished({ data: { hasMaximumBorrowingEstimateData: true } });
            }
            ctrl.isProcessing = false;
            ctrl.isReady = true;
          });
        }
      };

      ctrl.toggleLenders = () => {
        if (ctrl.maximumBorrowing?.idLenders?.length) {
          ctrl.maximumBorrowing.idLenders = [];
        } else {
          ctrl.maximumBorrowing.idLenders = _.map(ctrl.lenders, 'id');
        }
        ctrl.maximumBorrowingChanges();
      };

      ctrl.showErrorMessage = () =>
        !ctrl.maximumBorrowing?.expectedRate || !ctrl.maximumBorrowing?.idLenders?.length;

      ctrl.maximumBorrowingChanges = _.debounce(() => {
        ctrl.isReady = false;
        ctrl.isProcessing = true;
        ctrl.saveMaximumBorrowing();
      }, 2000);

      ctrl.saveMaximumBorrowing = () => {
        const data = {
          maximumBorrowing: ctrl.maximumBorrowing,
          hLCD: 'homeLoanMaximumBorrowing'
        };
        ctrl.onFinished({ data });
      };

      ctrl.destroyWatch = eventService.onChangedData((params) => {
        if (params?.changedData === 'homeLoanMaximumBorrowing') {
          if (ctrl.showErrorMessage()) {
            ctrl.isProcessing = false;
          } else {
            ctrl.getMaximumBorrowing();
          }
        }
      });

      ctrl.$onInit = () => {
        ctrl.initialize();
      };

      ctrl.$onDestroy = () => {
        ctrl.destroyWatch();
      };
    }
  }
};
